<template>
    <v-card tile class="dialog-content">
        <v-card-text v-if="message" v-html="message"/>
        <v-card-text v-else
        >Are you sure you want to delete {{ elementName }}?
        </v-card-text
        >
    </v-card>
</template>

<script>
  import { VCard, VCardText } from 'vuetify/lib'

  export default {
    components: {
      VCard,
      VCardText
    },
    props: {
      message: {
        type: String
      },
      elementName: {
        type: String,
        default: 'it'
      }
    }
  }
</script>
